<template>
    <div class="table-user border-accent" v-if="products.length > 0">
        <b-table hover
                :class="['table-bordered']"
                :items="items"
                :fields="fields">

            <template slot="empty" slot-scope="scope">
                <h4>{{ scope.emptyText }}</h4>
            </template>
            <template slot="img" slot-scope="data">
                <img v-if="data.item.img"
                    :src="data.item.img"
                    :alt="data.item.name"
                    width="50"
                    height="50">
            </template>
            <template slot="sku_fnsku" slot-scope="data">
                <span>{{data.item.sku}} / </span><span class="text-muted">{{data.item.fnsku}}</span>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: 'RuleProductsList',
        props: ['products', 'limit'],
        data() {
            return {
                fields: [
                    {
                        key: 'img',
                        label: 'Images',
                        variant: 'column-img'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        variant: ''
                    },
                    {
                        key: 'sku_fnsku',
                        label: 'SKU / FNSKU',
                        variant: ''
                    }
                ],
                dummy: [
                    {
                        name: 'ADIDAS | CLASSIC BACKPACK',
                        fnsku: 'E38WAENCFGCBYG7EUVXE',
                        sku: 'AD-03-black-OS',
                        img: 'http://boxiti-api.smart-gamma.com/images/products/5/d/5dde7bc8734f6665293456.jpg'
                    }
                ]
            }
        },
        computed: {
            items() {
                if (this.limit) {
                    let test = this.products.slice(0, this.limit)
                    return test
                }
                return this.products
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ShippingPolicySettings/components/RuleProductsList.vue